import Collaboration from "../../../../src/pages/use-cases/page-content/collaboration/student-teacher-collaboration.md";
import * as React from 'react';
export default {
  Collaboration,
  React
};